import {useAuth} from '../../modules/auth'
import DashboardApiTableShow, {DashboardColumn} from './DashboardApiTableShow'
import {
  renderDashboardDateTwoLine,
  renderDashboardContact,
  renderDashboardStatusPill,
  renderDashboardUserName,
} from './dashboardFormatters'
import {useVerifyTokenOnClick} from './useVerifyTokenOnClick'

const columns: DashboardColumn<any>[] = [
  {header: 'Name', sortKey: 'first_name', render: (item) => renderDashboardUserName(`${item.first_name ?? ''} ${item.last_name ?? ''}`, 'manage-buyers')},
  {header: 'Email', sortKey: 'email', minWidth: 180, render: (item) => renderDashboardContact('email', item.email)},
  {header: 'Mobile Number', sortKey: 'mobile_number', width: 160, render: (item) => renderDashboardContact('phone', item.mobile_number)},
  {header: 'Created', sortKey: 'created_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.created_at)},
  {header: 'Updated', sortKey: 'updated_at', width: 160, render: (item) => renderDashboardDateTwoLine(item.updated_at)},
  {
    header: 'Status',
    sortKey: 'status',
    width: 130,
    render: (item) => renderDashboardStatusPill(item.status === true ? 'Active' : 'Deactivate'),
  },
]

function TotalBuyersshow() {
  const {currentUser} = useAuth()
  useVerifyTokenOnClick()

  return (
    <DashboardApiTableShow
      endpoint='GetAllBuyer'
      title='Total Buyers'
      paginationTitle='Buyers'
      userTypeId={currentUser?.roles?.[0]?.id}
      columns={columns}
    />
  )
}

export default TotalBuyersshow
